import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RequestFileService} from '../../../_services/api/request-file.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-file-request-dialog',
  templateUrl: './create-file-request-dialog.component.html',
  styleUrls: ['./create-file-request-dialog.component.scss', '../../../../inputGroup.scss']
})
export class CreateFileRequestDialogComponent implements OnInit {

  createRequestFileForm: FormGroup;
  doneTime: number;

  requestType: 'link' | 'email';
  status: 'loading' | 'show-form' | 'done-send-email' | 'done-created-link';

  email: string;
  link: string;

  constructor(public dialogRef: MatDialogRef<CreateFileRequestDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private requestFile: RequestFileService,
              private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.status = 'show-form';
    this.requestType = 'link';

    this.createRequestFileForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      email_subject: [''],
      email_body: [''],
    });

    this.createRequestFileForm.get('email').valueChanges.subscribe(event => {
      this.createRequestFileForm.get('email').setValue(event.toLowerCase(), {emitEvent: false});
    });
  }

  close() {
    this.dialogRef.close(true);
  }

  submit(){
    this.status = 'loading';
    const params = this.createRequestFileForm.value;
    if (this.requestType === 'link'){
      delete params.email_subject;
      delete params.email_body;
    }
    params.requestType = this.requestType;
    this.requestFile.create(params).subscribe( res => {
      this.doneTime = Number(new Date().getTime());
      this.status = this.requestType === 'link' ? 'done-created-link' : 'done-send-email';
      this.link = res.link;
      this.email = res.email;
    });
  }

  copyLink() {
    this.requestFile.copyLink(this.link);
  }

  copyAndClose(){
    this.copyLink();
    this.dialogRef.close(true);
  }
}
